import type { Severity } from '@ametica/shared';
import { SEVERITY } from './severity';

/** Štítok závažnosti podľa prototypu (`sevBadge`): bodka + popisok, nikdy farba samotná. */
export function SeverityBadge({ severity }: { severity: Severity }) {
  const s = SEVERITY[severity];
  return (
    <span className={`pill border ${s.border}/45 ${s.bg}/20 ${s.text} font-medium`}>
      <span className={`dotst ${s.bg}`} />
      {s.label}
    </span>
  );
}
